module.exports = __webpack_public_path__ + "media/images/application/choose-price/poulpe-05-25c7adaa64a0f1c8de1d0bb926a23317.svg";